<template>
  <div v-if="!mainLoading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3">
              <router-link  to="/">{{$t('maintenanceslist.breadcrumb_1')}}</router-link>
            </li>
            <li>
              <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
              <i v-else class="fa-solid fa-chevron-right pt-1"></i>
            </li>
            <li class="mx-3 almarai-bold" aria-current="page">{{$t('nav.chats')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <div v-if="mainLoading" class="row">
      <div class="col text-center">
        <mainloader />
      </div>
    </div>
    <div v-if="!mainLoading" class="row justify-content-center">
        <div class="col-12 col-sm-10">
            <div class="card card-secondary card-outline mb-4 mt-5">
                <div class="card-header">
                    <div class="card-title">{{$t('nav.chats')}}</div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-sm-4 chat-list">
                            <ol class="list-group p-0">
                                <li v-for="row in rows" :key="row.id" class="list-group-item d-flex justify-content-between align-items-start">
                                    <a href="#" @click.prevent="getChannel(row.id)" class="a-no-css d-block w-100">
                                        <div class="ms-2 me-auto">
                                            <div v-if="row.data.member_count == 1" class="fw-bold">{{ $t('nav.customerService') }}</div>
                                            <div v-else class="fw-bold">{{ (usersName[row.id])? usersName[row.id] : 'محادثة' }}</div>
                                            <div class="date-format">{{ formatDate(row.data.last_message_at)  }}</div>
                                        </div>
                                        <span v-if="row.state.messages && row.state.messages.length == 1" class="badge text-bg-secondary rounded-pill chat-padge">جديد</span>
                                        <span v-if="row.state.unreadCount > 0" class="badge text-bg-secondary rounded-pill chat-padge">{{ row.state.unreadCount }}</span>
                                    </a>
                                </li>
                            </ol>
                        </div>

                        <div class="col-12 col-sm-8">
                            <div v-if="!currentChat" class="no-chat-selected">
                                <i class="fa-regular fa-comments"></i>
                            </div>
                            <div v-if="currentChat">
                                <div id="main-chat-div" class="chat-selected border-start p-2">
                                    <div v-for="message in currentChatMessages" :key="message.id">
                                        <div class="row mb-3" :style="(message.user.id != GET_USER_DATA.streamId)? 'direction: ltr;' : ''">
                                            <div class="col-auto">
                                                <div class="chat-img" :style="`background-image: url(${(message.user.image)? message.user.image : '/assets/images/user.png'})`"></div>
                                            </div>
                                            <div class="col pt-2">
                                                <strong>{{ message.user.name }}</strong>
                                                <p>{{ message.text }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="border p-2">
                                    <form action="" @submit.prevent="sendMessage">
                                        <div class="row">
                                            <div class="col">
                                                <input type="text" v-model="messageText" class="form-control">
                                            </div>
                                            <div class="col-auto">
                                                <input type="submit" class="btn btn-warning" value="ارسل" :disabled="messageLoader">
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { toast, formatDate } from '@/helpers/tools';
import { mapGetters } from 'vuex';

export default {
  name: 'ChatsList',
  data(){
    return {
      externalId: this.$route.query.id ?? null,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: 1,
      currentChat: null,
      currentChatCID: null,
      currentChatMessages: [],
      messageText: '',
      messageLoader: false,
      channelMessageEvent: null,
      chatMessageEvent: null,
      channelNewChannelEvent: null,
      userLang: 'ar',
      usersName: {},
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GET_USER_DATA', 'ISLOADING', 'CHAT_CLIENT'])
  },
  methods: {
    formatDate,
    getList(){
      // this.mainLoading = true;
      this.hasError = false;
      const filter = {
        type: "messaging", members: { $in: [this.GET_USER_DATA.streamId] },
        team: {$in: ['properties', 'exchanges', 'contactUs']}
      };
      const sort = [{ last_message_at: -1 }];
      const rowsPerPage = 30;
      const offset = (this.currentPage == 1)? 0 : (this.currentPage * rowsPerPage) - 1;
      const options = {
        limit: rowsPerPage, offset: offset, // watch: true, state: true
      };
      this.CHAT_CLIENT.queryChannels(filter, sort, options).then(rows => {
        for(let i=0; i<rows.length; i++){
          if(rows[i].data.member_count == 1)
            continue;
          for(let key in rows[i].state.members){
            if(key != this.GET_USER_DATA.streamId){
              this.usersName[rows[i].id] = rows[i].state.members[key].user.name;
              break;
            }
          }
        }
        
        this.rows = rows;
        this.channelMessageEvent = this.CHAT_CLIENT.on("message.new", (event) => {
          if(event.cid != `messaging:${this.currentChatCID}`){
            // this.chatClient.off("message.new");
            this.channelMessageEvent.unsubscribe();
            if(this.channelNewChannelEvent)
                this.channelNewChannelEvent.unsubscribe();
            this.getList();
          }
        });
        
        this.channelNewChannelEvent = this.CHAT_CLIENT.on("notification.added_to_channel", (event) => {
          this.channelNewChannelEvent.unsubscribe();
          if(this.channelMessageEvent)
            this.channelMessageEvent.unsubscribe();
          this.getList();
        });
        this.mainLoading = false;
      }).catch(err => {
        this.message = err.message;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    getChannel(id){
      if(this.chatMessageEvent)
        this.chatMessageEvent.unsubscribe();
      this.currentChatCID = id;
      this.currentChat = null;
      this.currentChatMessages = [];
      this.hasError = false;
      const filter = {type: "messaging", cid: {$eq: `messaging:${id}`}};
      const sort = [{ last_message_at: -1 }];
      const options = {
        limit: 1, //watch: true,
      };
      this.CHAT_CLIENT.queryChannels(filter, sort, options).then(async row => {
        this.currentChat = row[0];
        this.currentChatMessages = row[0].state.messages;
        // row[0].markRead();
        await this.currentChat.watch();
        await this.currentChat.markRead();
        setTimeout(() => this.chatScroll(), 200);

        for(let r=0; r<this.rows.length; r++){
          if(this.rows[r].id == id){
            this.rows[r].state.unreadCount = 0;
            break;
          }
        }
        
        this.chatMessageEvent = this.currentChat.on("message.new", (event) => {
          this.currentChatMessages = this.currentChat.state.messages;
          this.chatScroll();
          // if(event.user.id != this.GET_USER_DATA.streamId){
          // }
        });
      }).catch(err => {
        this.message = err.message;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    chatScroll(){
      const div = document.getElementById('main-chat-div');
      if(div){
        setTimeout(() => {
          div.scrollTo({
            top: div.scrollHeight,
            behavior: 'smooth'
          });
        }, 200);
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
    async connecting(){
      this.mainLoading = true;
      this.hasError = false;
      if(this.ISLOADING){
        setTimeout(() => this.connecting(), 200);
        return;
      }
      if(!this.GET_USER_DATA.streamToken){
        this.message = 'يرجى تسجيل الخروج وإعادة تسجيل الدخول';
        this.hasError = true;
        return;
      }
      if(!this.CHAT_CLIENT){
        this.message = 'خطأ في الإتصال بالمحادثات';
        this.hasError = true;
        return;
      }
      this.getList();
      if(this.externalId)
        this.getChannel(this.externalId);
    },
    sendMessage(){
      if(!this.messageText || this.messageText.trim() == ''){
        toast('يجب كتابة الرسالة اولاً');
        return false;
      }
      if(!this.currentChat){
        toast('يجب اختيار المحادثة اولاً');
        return false;
      }
      this.messageLoader = true;
      this.currentChat.sendMessage({
        text: this.messageText,
      }).then(() => {
        this.messageText = '';
        this.messageLoader = false;
      }).catch(err => {
        toast('غير قادر على إرسال الرسالة');
        this.messageLoader = false;
      });
    },
  },
  created(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    this.connecting();
  },
  unmounted(){
    if(this.channelMessageEvent)
      this.channelMessageEvent.unsubscribe();
    if(this.chatMessageEvent)
      this.chatMessageEvent.unsubscribe();
    if(this.channelNewChannelEvent)
      this.channelNewChannelEvent.unsubscribe();
  }
}
</script>
<style>
.a-no-css,
.a-no-css:hover,
.a-no-css:focus,
.a-no-css:active {
  text-decoration: none;
  color: inherit;
}
.no-chat-selected {
  display: flex;
  color: #DDD;
  justify-content: center;
  height: 500px;
  align-items: center;
  font-size: 80px;
}
.chat-selected {
  height: 500px;
  overflow-y: scroll;
}
.chat-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-size: contain;
}
.chat-padge {
  position: absolute;
  left: 15px;
  top: 15px;
}
.chat-list {
  overflow-y: scroll;
  height: 550px;
}
</style>
